import { TableActions, TableStates } from "../tables/constants";

const DEFAULT_PAGE_SIZE = 50;
const PAGE_SIZE_VARIANTS = [20, DEFAULT_PAGE_SIZE, 100];

const state = {
    hiddenColumns: {},
    fixedColumns: {},
    pages: {},
    pageSizes: {},
    filters: {},
    search: {}
};


const getters = {
    getTablePageSize: (s) => (name) => {
        if (s.pageSizes.hasOwnProperty(name)) {
            return s.pageSizes[name]
        }
        return DEFAULT_PAGE_SIZE;
    },
    getTablePageSizeVariants: (s) => {
        return PAGE_SIZE_VARIANTS
    },
    getTableHiddenColumnNames: (s) => (name) => {
        if (s.hiddenColumns.hasOwnProperty(name)) {
            return s.hiddenColumns[name]
        }
        return [];
    },
    getTableFixedColumnNames: (s) => (name) => {
        if (s.fixedColumns.hasOwnProperty(name)) {
            return s.fixedColumns[name]
        }
        return [];
    },
    getFilters: (s) => (tableName) => {
        if (s.filters.hasOwnProperty(tableName)) {
            return s.filters[tableName]
        }
        return []
    },
    isColumnHidden: (s, getters) => (tableName, columnName) => {
        const hiddenColumns = getters.getTableHiddenColumnNames(tableName);
        return hiddenColumns.indexOf(columnName) >= 0;
    },
    isColumnFixed: (s, getters) => (tableName, columnName) => {
        const fixedColumns = getters.getTableFixedColumnNames(tableName);
        return fixedColumns.indexOf(columnName) >= 0;
    },
    getStoredSearch: (s) => (tableName) => {
        if (s.search.hasOwnProperty(tableName)) {
            return s.search[tableName]
        }
        return null;
    },
    getStoredPage: (s) => (tableName) => {
        if (s.pages.hasOwnProperty(tableName)) {
            return s.pages[tableName]
        }
        return 1;
    }
};

const mutations = {
    [TableStates.TABLE_COLUMN_VISIBILITY]: (state, payload) => {
        let hiddenColumns = {...state.hiddenColumns};
        hiddenColumns[payload.name] = payload.columns;
        state.hiddenColumns = hiddenColumns;
    },
    [TableStates.TABLE_COLUMN_POSITION]: (state, payload) => {
        let fixedColumns = {...state.fixedColumns};
        fixedColumns[payload.name] = payload.columns;
        state.fixedColumns = fixedColumns;
    },
    [TableStates.TABLE_PAGE_SIZE]: (state, payload) => {
        let pageSizes = {...state.pageSizes};
        pageSizes[payload.name] = payload.size;
        state.pageSizes = pageSizes;
    },
    [TableStates.TABLE_CURRENT_PAGE]: (state, payload) => {
        let pages = {...state.pages};
        pages[payload.name] = payload.page;
        state.pages = pages;
    },
    [TableStates.TABLE_FILTERS]: (state, payload) => {
        let filters = {...state.filters};
        filters[payload.name] = payload.filterData;
        state.filters = filters;
    },
    [TableStates.TABLE_SEARCH]: (state, payload) => {
        let search = {...state.search};
        search[payload.name] = payload.search;
        state.search = search;
    },
    [TableStates.TABLE_EMPTY_FILTERS]: (state) => {
        state.filters = {};
    },
    [TableStates.TABLE_EMPTY_SEARCH]: (state) => {
        state.search = {};
    },
};

const actions = {
    [TableActions.TABLE_CHANGE_COLUMN_VISIBILITY]: ({commit}, payload) => {
        commit(TableStates.TABLE_COLUMN_VISIBILITY, payload);
    },
    [TableActions.TABLE_CHANGE_COLUMN_POSITION]: ({commit}, payload) => {
        commit(TableStates.TABLE_COLUMN_POSITION, payload);
    },
    [TableActions.TABLE_CHANGE_PAGE_SIZE]: ({commit}, payload) => {
        commit(TableStates.TABLE_PAGE_SIZE, payload);
    },
    [TableActions.TABLE_SET_CURRENT_PAGE]: ({commit}, payload) => {
        commit(TableStates.TABLE_CURRENT_PAGE, payload);
    },
    [TableActions.TABLE_CHANGE_FILTERS]: ({commit}, payload) => {
        commit(TableStates.TABLE_FILTERS, payload);
    },
    [TableActions.TABLE_CHANGE_SEARCH]: ({commit}, payload) => {
        commit(TableStates.TABLE_SEARCH, payload);
    },
    [TableActions.TABLE_RESET_FILTERS]: ({commit}) => {
        commit(TableStates.TABLE_EMPTY_FILTERS);
    },
    [TableActions.TABLE_RESET_SEARCH]: ({commit}) => {
        commit(TableStates.TABLE_EMPTY_SEARCH);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}
